import { i18n } from "i18next";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocalStorage } from "usehooks-ts";

export type LanguageCode = "it" | "en" | "de" | "fr" | "es";

const languageIdMap: Record<number, LanguageCode> = {
	0: "it",
	1: "en",
	2: "de",
	3: "fr",
	4: "es",
};

export function getPlatformLanguageFromI18n(i18n: i18n): number {
	const lang = i18n.language.split("-")[0]; // Handle variants like it-IT, de-DE

	// Find the ID for the current language
	for (const [id, code] of Object.entries(languageIdMap)) {
		if (code === lang) {
			return parseInt(id);
		}
	}

	// Default to English if language not found
	return 1;
}

export function getLanguageCodeFromId(id: number): LanguageCode {
	return languageIdMap[id] || "en";
}

const useLanguageSwitcher = () => {
	const { i18n } = useTranslation();

	const [selectedLanguageId] = useLocalStorage("platform-language", getPlatformLanguageFromI18n(i18n));
	useEffect(() => {
		i18n.changeLanguage(getLanguageCodeFromId(selectedLanguageId));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedLanguageId]);
};
export default useLanguageSwitcher;

export const useSelectedLanguage = (): LanguageCode => {
	const { i18n } = useTranslation();

	const [selectedLanguageId] = useLocalStorage("platform-language", getPlatformLanguageFromI18n(i18n));
	return getLanguageCodeFromId(selectedLanguageId);
};
